// Lógica pura del timeout por inactividad. Sin React, 100% testeable en node.
// La fase se computa SIEMPRE contra reloj de pared (lastActivity + ventana),
// nunca contando ticks — así una pestaña en background que perdió timers
// resuelve correctamente al recuperar el foco.

/** Inactividad máxima antes de cerrar la sesión (40 min). */
export const IDLE_LIMIT_MS = 40 * 60 * 1000;
/** Cuánto antes del cierre se muestra el modal de aviso (60 s). */
export const WARNING_MS = 60 * 1000;
/** Clave compartida entre pestañas para la última actividad del usuario. */
export const LAST_ACTIVITY_KEY = 'session_last_activity';
/** Throttle de escrituras de actividad a localStorage (evita thrashing). */
export const ACTIVITY_WRITE_THROTTLE_MS = 5 * 1000;

export type SessionPhase = 'active' | 'warning' | 'expired';

/** Milisegundos hasta el cierre (negativo si ya venció). */
export function msUntilLogout(lastActivityMs: number, nowMs: number): number {
  return lastActivityMs + IDLE_LIMIT_MS - nowMs;
}

/** Fase actual de la sesión según la inactividad acumulada. */
export function getSessionPhase(lastActivityMs: number, nowMs: number): SessionPhase {
  const remaining = msUntilLogout(lastActivityMs, nowMs);
  if (remaining <= 0) return 'expired';
  if (remaining <= WARNING_MS) return 'warning';
  return 'active';
}

/** Segundos restantes hasta el cierre, redondeados hacia arriba y nunca negativos. */
export function secondsUntilLogout(lastActivityMs: number, nowMs: number): number {
  return Math.max(0, Math.ceil(msUntilLogout(lastActivityMs, nowMs) / 1000));
}
